import { styled } from '@mui/material/styles';

export type StepCalloutStatus = 'done' | 'next';

export const StepCallout = styled('div', {
  shouldForwardProp: prop => prop !== 'status',
})<{ status: StepCalloutStatus }>(({ theme, status }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  ...(status === 'done'
    ? { backgroundColor: theme.palette.success.lighter, color: theme.palette.success.main }
    : { border: `1px solid ${theme.palette.primary.main}`, color: theme.palette.primary.main }),
}));
